export default __webpack_public_path__ + "static/media/work-experience.0dc0aa7b4421f4af478c89e84f9bff65.svg";